import { v4 } from 'uuid';

const useForceReactivity = () => {
    const identifier = v4();
    const refreshCount = ref(0);
    const key = computed(() => `${identifier}-${refreshCount.value}`);

    const force = () => {
        refreshCount.value++;
    };

    return { force, key };
};

export default useForceReactivity;
